class BdCoaLookup extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    // Load messages from data-messages attribute
    const raw = this.getAttribute('data-messages');
    console.log('📨 Raw messages attribute:', raw);

    this.messages = raw ? JSON.parse(raw) : {};

    // Provide safe defaults
    this.messages = {
      empty: 'Please enter a code.',
      checking: 'Looking up…',
      notFound: 'No matching entry found.',
      error: 'An error occurred.',
      ...this.messages, // user overrides
    };

    console.log(this.messages, 'OUR MESSAGES');

    this.form = this.querySelector('.bd-coa-form');
    this.input = this.querySelector('.bd-coa-input');
    this.message = this.querySelector('.bd-coa-message');

    if (!this.form || !this.input) return;

    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }
 
  onSubmit(event) {
    event.preventDefault();

    const code = this.input.value.trim();

    if (!code) {
      if (this.message) this.message.textContent = this.messages.empty;
      return;
    }

    if (this.message) {
      this.message.textContent = `${this.messages.checking} "${code}"…`;
    }

    this.lookup(code);
  }

  async lookup(code) {
    console.log('🔍 Starting lookup for code:', code);

    const normalized = normalizeHandle(code);
    const url = `/pages/coa-item/${normalized}`;

    if (this.message) {
      this.message.textContent = `${this.messages.checking} "${code}"…`;
    }

    try {
      let response = await fetch(url, { method: 'HEAD' });

      if (!response.ok && response.status !== 404) {
        console.warn('HEAD failed, retrying with GET');
        response = await fetch(url, { method: 'GET' });
      }

      console.log('🔎 URL check response:', response.status);

      if (response.ok) {
        console.log('➡️ Redirecting to:', url);
          window.location.href = url;
        return;
      }

      if (response.status === 404) {
        console.warn('⚠️ Page not found:', url);
        if (this.message) {
          this.message.textContent = this.messages.notFound;
        }
        return;
      }

      console.error('Unexpected response:', response.status);
      if (this.message) {
        this.message.textContent = this.messages.error;
      }
    } catch (err) {
      console.error('💥 Lookup error:', err);
      if (this.message) {
        this.message.textContent = this.messages.error;
      }
    }
  }
}

customElements.define('bd-coa-lookup', BdCoaLookup);

function normalizeHandle(input) {
  return (
    input
      .trim()
      .toLowerCase()
      // Insert hyphens between letter→number and number→letter boundaries
      .replace(/([a-z])([0-9])/g, '$1-$2')
      .replace(/([0-9])([a-z])/g, '$1-$2')
      // Replace anything not a-z or 0-9 with hyphens
      .replace(/[^a-z0-9]+/g, '-')
      // Collapse multiple hyphens
      .replace(/-+/g, '-')
      // Trim hyphens from start/end
      .replace(/^-|-$/g, '')
  );
}
